import Name from "./user-name"
import Avatar from "./user-avatar"

const User = { Name, Avatar }

export default User
